/* ELORA — comportements de la boutique. Vanilla, aucune dependance.

   Le fichier est appele par plusieurs sections : sans ce garde, chaque bouton
   recevrait autant d'ecouteurs qu'il y a de sections, et un clic basculerait
   l'accordeon un nombre pair de fois — donc visuellement rien. */
(function () {
  'use strict';
  if (window.__eloraBooted) return;
  window.__eloraBooted = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Format monetaire (les 5 jetons de Shopify) ---------- */
  function money(cents, format) {
    format = format || '{{amount}}';
    function grp(thousands, decimal, places) {
      var parts = (cents / 100).toFixed(places).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return places ? parts.join(decimal) : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, t) {
      switch (t) {
        case 'amount_no_decimals': return grp(',', '.', 0);
        case 'amount_with_comma_separator': return grp('.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return grp('.', ',', 0);
        case 'amount_with_apostrophe_separator': return grp("'", '.', 2);
        default: return grp(',', '.', 2);
      }
    });
  }
  function fmt() { return (document.body.dataset.eloraMoney) || '{{amount}}'; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Barre d'annonce ---------- */
  $$('[data-el-bar]').forEach(function (bar) {
    var track = $('[data-el-bar-track]', bar);
    var slides = $$('.el-bar__slide', track);
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % slides.length;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
    }, parseInt(bar.dataset.elBar, 10) || 3000);
  });

  /* ---------- Heros ---------- */
  $$('[data-el-hero]').forEach(function (hero) {
    var track = $('[data-el-hero-track]', hero);
    var slides = $$('.el-hero__slide', track);
    var puces = $$('[data-el-hero-puce]', hero);
    if (slides.length < 2) return;
    var i = 0, timer = null;

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      puces.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
    }
    function relancer() {
      clearInterval(timer);
      timer = setInterval(function () { go(i + 1); }, (parseInt(hero.dataset.interval, 10) || 10) * 1000);
    }

    var prec = $('[data-el-hero-prec]', hero);
    var suiv = $('[data-el-hero-suiv]', hero);
    if (prec) prec.addEventListener('click', function () { go(i - 1); relancer(); });
    if (suiv) suiv.addEventListener('click', function () { go(i + 1); relancer(); });
    puces.forEach(function (p) {
      p.addEventListener('click', function () { go(Number(p.dataset.elHeroPuce)); relancer(); });
    });

    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); relancer(); }
      x0 = null;
    }, { passive: true });

    go(0);
    relancer();
  });

  /* ---------- Familles en avant : la pastille change la photo ----------

     La pastille reste un lien vers la fiche du coloris ; le survol ne fait
     qu'un apercu, pour que la carte montre les autres coloris sans les
     empiler dans la grille. */
  $$('.el-fam__carte').forEach(function (carte) {
    var img = $('[data-el-fam-img]', carte);
    var lien = $('[data-el-fam-lien]', carte);
    var pastilles = $$('[data-el-fam-pastille]', carte);
    if (!img || !pastilles.length) return;

    var srcInitial = img.getAttribute('src');
    var setInitial = img.getAttribute('srcset');
    var hrefInitial = lien ? lien.getAttribute('href') : null;

    function montre(p) {
      if (!p.dataset.src) return;
      img.setAttribute('src', p.dataset.src);
      if (p.dataset.srcset) img.setAttribute('srcset', p.dataset.srcset);
      if (lien) lien.setAttribute('href', p.getAttribute('href'));
      pastilles.forEach(function (q) { q.classList.toggle('is-active', q === p); });
    }
    function reviens() {
      img.setAttribute('src', srcInitial);
      if (setInitial) img.setAttribute('srcset', setInitial);
      if (lien && hrefInitial) lien.setAttribute('href', hrefInitial);
      pastilles.forEach(function (q, i) { q.classList.toggle('is-active', i === 0); });
    }

    pastilles.forEach(function (p) {
      p.addEventListener('mouseenter', function () { montre(p); });
      p.addEventListener('focus', function () { montre(p); });
    });
    carte.addEventListener('mouseleave', reviens);
  });

  /* ---------- Mur social : les videos ne tournent qu'a l'ecran ---------- */
  if ('IntersectionObserver' in window) {
    var vues = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { if (v.readyState === 0) v.load(); v.play().catch(function () {}); }
        else v.pause();
      });
    }, { rootMargin: '150px' });
    $$('[data-el-insta-video]').forEach(function (v) { vues.observe(v); });
  }

  /* ---------- Tiroirs ---------- */
  function openDrawer(d) {
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.el-drawer.is-open')) document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-el-drawer-open]');
    if (open) { e.preventDefault(); openDrawer(document.getElementById(open.dataset.elDrawerOpen)); return; }
    var close = e.target.closest('[data-el-drawer-close], .el-drawer__veil');
    if (close) { e.preventDefault(); closeDrawer(close.closest('.el-drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.el-drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Accordeons ----------
     La hauteur est posee en style inline : aucune feuille du theme hote ne
     peut la surcharger, contrairement a une classe. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-el-acc-btn], [data-el-subnav]');
    if (!btn) return;
    var body = document.getElementById(btn.getAttribute('aria-controls'));
    if (!body) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    body.classList.toggle('is-open', !open);
    body.style.overflow = 'hidden';
    if (open) {
      body.style.maxHeight = body.scrollHeight + 'px';
      requestAnimationFrame(function () { body.style.maxHeight = '0px'; });
    } else {
      body.style.maxHeight = body.scrollHeight + 'px';
      setTimeout(function () {
        if (btn.getAttribute('aria-expanded') === 'true') body.style.maxHeight = 'none';
      }, 400);
    }
  });

  /* ---------- Avis : tout afficher ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-el-reviews-more]');
    if (!b) return;
    var open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', String(!open));
    $$('.el-reviews__review--extra').forEach(function (r) { r.hidden = open; });
    b.querySelector('span').textContent = open ? 'Show all reviews' : 'Show fewer reviews';
  });

  /* ---------- Galerie ---------- */
  $$('[data-el-gallery]').forEach(function (g) {
    var track = $('[data-el-gallery-track]', g);
    var slides = $$('.el-gallery__slide', track);
    var fill = $('[data-el-gallery-fill]', g);
    if (!slides.length) return;
    var index = 0;

    function go(n) {
      index = Math.max(0, Math.min(slides.length - 1, n));
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      if (fill) fill.style.transform = 'scaleX(' + (index + 1) / slides.length + ')';
    }
    go(0);

    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    g.addEventListener('el:media', function (e) {
      var i = slides.findIndex(function (s) { return s.dataset.mediaId === String(e.detail.mediaId); });
      if (i > -1) go(i);
    });

    // Visionneuse : seul endroit du site ou l'on peut agrandir une image.
    var zoom = $('[data-el-zoom]', g);
    if (zoom) {
      zoom.addEventListener('click', function () {
        var src = slides[index].querySelector('img');
        if (!src) return;
        var box = document.createElement('div');
        box.className = 'el-lightbox';
        box.innerHTML =
          '<button type="button" class="el-lightbox__close" aria-label="Close">&times;</button>' +
          '<img src="' + esc(src.currentSrc || src.src) + '" alt="' + esc(src.alt) + '">';
        var big = false;
        var im = box.querySelector('img');
        im.addEventListener('click', function () {
          big = !big;
          im.style.transform = big ? 'scale(2.4)' : 'scale(1)';
          im.style.cursor = big ? 'zoom-out' : 'zoom-in';
        });
        box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('.el-lightbox__close')) box.remove(); });
        document.body.appendChild(box);
      });
    }
  });

  /* ---------- Panier deroulant ---------- */
  var cart = $('[data-el-cart]');

  // Table variante -> prix barre, posee par la section en-tete.
  var barres = {};
  try {
    var tableBarres = $('[data-el-barres]');
    if (tableBarres) barres = JSON.parse(tableBarres.textContent) || {};
  } catch (e) { barres = {}; }

  function lineHtml(it) {
    var opts = (it.options_with_values || []).map(function (o) {
      return esc(o.name) + ': ' + esc(o.value);
    }).join('&nbsp;&nbsp; ');
    var barre = Math.max(it.original_price || 0, barres[it.variant_id] || 0);
    var compare = barre > it.final_price
      ? '<del>' + money(barre, fmt()) + '</del><ins>' + money(it.final_price, fmt()) + '</ins>'
      : '<span>' + money(it.final_price, fmt()) + '</span>';
    return '' +
      '<div class="el-cart__line" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '">' +
          (it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2')) + '" alt="' + esc(it.product_title) + '">' : '<span></span>') +
        '</a>' +
        '<div>' +
          '<a href="' + esc(it.url) + '" class="el-cart__name">' + esc(it.product_title) + '</a>' +
          (opts ? '<div class="el-cart__opts">' + opts + '</div>' : '') +
          '<div class="el-cart__price">' + compare + '</div>' +
          '<div class="el-cart__qty">' +
            '<button type="button" data-el-qty="-1" aria-label="Decrease">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-el-qty="1" aria-label="Increase">+</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="el-cart__remove" data-el-remove aria-label="Remove">' +
          '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M18 6L6 18" stroke="currentColor" stroke-linecap="square"/><path d="M6 6L18 18" stroke="currentColor" stroke-linecap="square"/></svg>' +
        '</button>' +
      '</div>';
  }

  function miniHtml(it) {
    var opts = (it.options_with_values || []).map(function (o) { return esc(o.value); }).join(' / ');
    return '' +
      '<div class="el-cart__mini">' +
        (it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')) + '" alt="' + esc(it.product_title) + '">' : '<span></span>') +
        '<div><span class="el-cart__mini-name">' + esc(it.product_title) + '</span>' +
        (opts ? '<span class="el-cart__opts">' + opts + '</span>' : '') + '</div>' +
      '</div>';
  }

  function bundleHtml(items, prix, mention) {
    // Le total vient des articles eux-memes : il reste juste meme si le tiroir est
    // ouvert sur une page qui n'a pas de section produit, ou apres un rechargement.
    var total = items.reduce(function (n, i) {
      return n + (typeof i.final_line_price === 'number' ? i.final_line_price : (i.final_price || 0));
    }, 0) || prix;
    // Meme base que la fiche produit : le prix barre de la variante quand il existe,
    // sinon le prix courant. Sans cela le lot afficherait 2 x prix soldé au lieu du plein tarif.
    var barre = items.reduce(function (n, i) {
      return n + Math.max(i.original_price || 0, barres[i.variant_id] || 0, i.final_price || 0);
    }, 0);
    return '' +
      '<div class="el-cart__bundle" data-keys="' + items.map(function (i) { return esc(i.key); }).join(' ') + '">' +
        '<div class="el-cart__bundle-head">' +
          '<span class="el-cart__bundle-nom">Any two pieces' +
            (mention ? ' <em>' + esc(mention) + '</em>' : '') + '</span>' +
          '<button type="button" class="el-cart__remove" data-el-remove-bundle aria-label="Remove bundle">' +
            '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M18 6L6 18" stroke="currentColor" stroke-linecap="square"/><path d="M6 6L18 18" stroke="currentColor" stroke-linecap="square"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="el-cart__bundle-items">' + items.map(miniHtml).join('') + '</div>' +
        '<div class="el-cart__bundle-foot">' +
          (barre > total ? '<del>' + money(barre, fmt()) + '</del>' : '') +
          '<ins>' + money(total, fmt()) + '</ins>' +
        '</div>' +
      '</div>';
  }

  function paint(data) {
    $$('[data-el-cart-count]').forEach(function (el) { el.textContent = data.item_count; });
    if (!cart) return;
    var body = $('[data-el-cart-body]', cart);
    var foot = $('[data-el-cart-foot]', cart);
    if (!data.items.length) {
      body.innerHTML = '<p class="el-cart__empty">Your cart is empty.</p>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;

    // Les deux vestes d'un lot sont regroupees en une seule carte.
    var lots = [];
    var seuls = [];
    data.items.forEach(function (it) {
      if (it.properties && it.properties._elora_bundle) lots.push(it);
      else seuls.push(it);
    });

    var html = '';
    var lotSrc = document.querySelector('[data-el-lot]');
    var lotPrix = Number(cart.dataset.lotPrix || (lotSrc && lotSrc.dataset.lotPrix) || 0);
    var lotMention = cart.dataset.lotMention || (lotSrc && lotSrc.dataset.lotMention) || '';
    while (lots.length >= 2) html += bundleHtml(lots.splice(0, 2), lotPrix, lotMention);
    html += lots.map(lineHtml).join('');
    html += seuls.map(lineHtml).join('');
    body.innerHTML = html;
    $('[data-el-cart-total]', cart).textContent = money(data.total_price, fmt());
  }

  function refresh(open) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { paint(d); if (open) openDrawer(cart); return d; });
  }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(paint);
  }

  if (cart) {
    cart.addEventListener('click', function (e) {
      var bundle = e.target.closest('[data-el-remove-bundle]');
      if (bundle) {
        var keys = bundle.closest('.el-cart__bundle').dataset.keys.split(' ');
        keys.reduce(function (chain, k) {
          return chain.then(function () { return change(k, 0); });
        }, Promise.resolve());
        return;
      }
      var line = e.target.closest('.el-cart__line');
      if (!line) return;
      var key = line.dataset.key;
      var qtyBtn = e.target.closest('[data-el-qty]');
      if (qtyBtn) {
        var n = parseInt(line.querySelector('.el-cart__qty span').textContent, 10) + parseInt(qtyBtn.dataset.elQty, 10);
        change(key, Math.max(0, n));
        return;
      }
      if (e.target.closest('[data-el-remove]')) change(key, 0);
    });
    refresh(false);
  }

  /* ---------- Fiche produit ---------- */
  $$('[data-el-product]').forEach(function (root) {
    var data = $('[data-el-variants]', root);
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = $('[data-el-variant-id]', root);
    var addBtn = $('[data-el-add]', root);
    var priceBox = $('[data-el-price]', root);
    var errBox = $('[data-el-error]', root);
    var gallery = $('[data-el-gallery]');

    function current() {
      var c = $('input[name="elora-size"]:checked', root);
      return c ? variants.find(function (v) { return v.option1 === c.value; }) || null : null;
    }

    function render() {
      var v = current();
      if (!v) return;
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (priceBox) {
        priceBox.innerHTML = v.compare_at_price && v.compare_at_price > v.price
          ? '<div class="el-price__inner"><span class="el-visually-hidden">Regular price</span><del>' +
            money(v.compare_at_price, fmt()) + '</del><span class="el-visually-hidden">Sale price</span><ins>' +
            money(v.price, fmt()) + '</ins></div><span class="el-price__badge">Sale</span>'
          : '<div class="el-price__inner"><span class="el-price__single">' + money(v.price, fmt()) + '</span></div>';
      }
      var p1 = $('[data-el-palier-prix-1]', root);
      var b1 = $('[data-el-palier-barre-1]', root);
      if (p1) p1.textContent = money(v.price, fmt());
      if (b1) b1.textContent = money(v.compare_at_price, fmt());
      if (v.featured_media_id && gallery) {
        gallery.dispatchEvent(new CustomEvent('el:media', { detail: { mediaId: v.featured_media_id } }));
      }
      if (errBox) errBox.textContent = '';
    }

    $$('input[name="elora-size"]', root).forEach(function (i) { i.addEventListener('change', render); });
    render();

    /* ----- Lot deux vestes ----- */
    var lot = $('[data-el-lot]', root);
    var lotCorps = lot && $('[data-el-lot-corps]', lot);
    var lotTailles = lot && $('[data-el-lot-tailles]', lot);
    var lotErr = lot && $('[data-el-lot-error]', lot);
    var secondId = null;

    function lotActif() {
      var c = lot && $('[data-el-palier]:checked', lot);
      return !!c && c.value === '2';
    }

    function peindreTailles() {
      if (!lot || !lotTailles) return;
      var m = $('[data-el-lot-modele]:checked', lot);
      if (!m) return;
      var json = $('[data-el-lot-famille="' + m.value + '"]', lot);
      var vars = json ? JSON.parse(json.textContent) : [];
      secondId = null;
      lotTailles.innerHTML = vars.map(function (v, i) {
        var id = 'el-lot-t-' + m.value + '-' + i;
        return '<span class="el-size">' +
          '<input type="radio" name="el-lot-taille" id="' + id + '" value="' + v.id + '"' +
          (v.available ? '' : ' disabled') + '>' +
          '<label for="' + id + '">' + esc(v.option1) + '</label></span>';
      }).join('');
      if (lotErr) lotErr.textContent = '';
    }

    if (lot) {
      $$('[data-el-palier]', lot).forEach(function (r) {
        r.addEventListener('change', function () {
          $$('.el-lot__palier', lot).forEach(function (l) {
            l.classList.toggle('is-active', l.contains(r) && r.checked);
          });
          lotCorps.hidden = !lotActif();
          if (lotActif()) peindreTailles();
        });
      });
      $$('[data-el-lot-modele]', lot).forEach(function (r) {
        r.addEventListener('change', peindreTailles);
      });
      lotTailles.addEventListener('change', function (e) {
        if (e.target.name === 'el-lot-taille') { secondId = e.target.value; if (lotErr) lotErr.textContent = ''; }
      });
    }

    var form = $('[data-el-form]', root);
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = current();
      if (!v) { if (errBox) errBox.textContent = 'Please select a size.'; return; }

      var items = [{ id: v.id, quantity: 1 }];
      if (lotActif()) {
        if (!secondId) { if (lotErr) lotErr.textContent = 'Please choose a size for your second piece.'; return; }
        // Marqueur technique (prefixe _ : invisible pour le client et sur la commande)
        var tag = { _elora_bundle: 'two-coats' };
        items[0].properties = tag;
        items.push({ id: Number(secondId), quantity: 1, properties: tag });
        if (cart) {
          cart.dataset.lotPrix = lot.dataset.lotPrix || '';
          cart.dataset.lotMention = lot.dataset.lotMention || '';
        }
      }

      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, b: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.b.description || res.b.message || 'Could not add to cart.');
          return refresh(true);          // le panier s'ouvre tout seul
        })
        .catch(function (err) { if (errBox) errBox.textContent = err.message; })
        .finally(function () { addBtn.disabled = false; render(); });
    });
  });
})();
